(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-image-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(section) {
      if (!section || section.dataset.mfCarouselInit === 'true') return;
      section.dataset.mfCarouselInit = 'true';

      var track = section.querySelector('[data-track]');
      var slides = Array.prototype.slice.call(section.querySelectorAll('[data-slide]'));
      var dotsContainer = section.querySelector('[data-dots]');
      var dots = dotsContainer ? Array.prototype.slice.call(dotsContainer.querySelectorAll('.mf-carousel__dot')) : [];
      var prevBtn = section.querySelector('.mf-carousel__arrow--prev');
      var nextBtn = section.querySelector('.mf-carousel__arrow--next');

      if (!track || !slides.length) return;

      var currentIndex = 0;

      function applyActive(index) {
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === index);
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      function goToIndex(index, smooth) {
        if (index < 0) index = 0;
        if (index > slides.length - 1) index = slides.length - 1;
        currentIndex = index;

        var slide = slides[index];
        if (!slide) return;

        applyActive(index);

        var trackRect = track.getBoundingClientRect();
        var slideRect = slide.getBoundingClientRect();
        var trackCenter = trackRect.left + trackRect.width / 2;
        var slideCenter = slideRect.left + slideRect.width / 2;
        var delta = slideCenter - trackCenter;
        var targetScrollLeft = track.scrollLeft + delta;

        track.scrollTo({
          left: targetScrollLeft,
          behavior: smooth === false ? 'auto' : 'smooth'
        });
      }

      function updateActiveOnScroll() {
        var trackRect = track.getBoundingClientRect();
        var centerX = trackRect.left + trackRect.width / 2;
        var closestIndex = 0;
        var closestDistance = Infinity;

        slides.forEach(function (slide, i) {
          var rect = slide.getBoundingClientRect();
          var slideCenter = rect.left + rect.width / 2;
          var distance = Math.abs(slideCenter - centerX);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = i;
          }
        });

        if (closestIndex !== currentIndex) {
          currentIndex = closestIndex;
          applyActive(currentIndex);
        }
      }

      // 初始：第一张居中
      setTimeout(function () {
        goToIndex(0, false);
      }, 80);

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            updateActiveOnScroll();
            ticking = false;
          });
          ticking = true;
        }
      });

      window.addEventListener('resize', function () {
        goToIndex(currentIndex, false);
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goToIndex(currentIndex - 1, true);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goToIndex(currentIndex + 1, true);
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(dot.getAttribute('data-index'), 10);
          if (!isNaN(index)) {
            goToIndex(index, true);
          }
        });
      });
    }

    function initAllCarousels() {
      var sections = document.querySelectorAll('.mf-carousel');
      Array.prototype.forEach.call(sections, function (section) {
        initCarousel(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllCarousels);
    } else {
      initAllCarousels();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var container = event.target;
      if (!container) return;
      var section = container.querySelector('.mf-carousel');
      if (section) {
        initCarousel(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
